import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import mailImg from 'assets/brand/mail.png';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Image from 'components/_core/Modal/components/Image';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import { logEvent } from 'features/Analytics/analytics';
import TrackView from 'features/Analytics/TrackView';
import * as ContentLayout from 'layouts/ContentLayout';

import * as routes from '../../routes';
import locales from './locales';

const AskQuestionConfirmation: FC = () => {
  const history = useHistory();
  return (
    <ContentLayout.Root>
      <TrackView pageName="AskQuestionConfirmation" />
      <ContentLayout.Body>
        <SunshineCard.Group>
          <SunshineCard
            alignItems="center"
            padding="space-32"
            textAlign="center"
          >
            <Image
              alt={locales.title}
              marginBottom="space-24"
              marginTop="space-24"
              src={mailImg}
              width="180px"
            />

            <Heading marginBottom="space-16" size="lg">
              {locales.title}
            </Heading>

            <Text marginBottom="space-24">{locales.subtitle}</Text>
          </SunshineCard>

          <SunshineCard>
            <SunshineCard.Content alignItems="center" padding="space-8">
              <Button
                isExpanded
                onClick={() => {
                  logEvent({
                    name: 'Back Button Clicked Ask Question Confirmation',
                  });
                  history.push(routes.root);
                }}
              >
                {locales.submit}
              </Button>
            </SunshineCard.Content>
          </SunshineCard>
        </SunshineCard.Group>
      </ContentLayout.Body>
    </ContentLayout.Root>
  );
};

export default AskQuestionConfirmation;
